export const LineItemCost = ({
	label,
	value,
}: {
	label: string;
	value: string;
}) => {
	return (
		<div className={"price-line-item"} data-testid={"shipment-charge"}>
			<p data-testid={"shipment-charge-description"}>{label}</p>
			<p data-testid={"shipment-charge-amount"}>{value}</p>
		</div>
	);
};
